var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-cebab",class:`button-cebab_${_vm.classModificator}`,attrs:{"disabled":_vm.disabled}},[_c('span',{staticClass:"button-cebab__dot"}),_vm._v(" "),_c('span',{staticClass:"button-cebab__dot"}),_vm._v(" "),_c('span',{staticClass:"button-cebab__dot"})])
}
var staticRenderFns = []

export { render, staticRenderFns }